import { createEffect } from "solid-js";
import { APP_STORE_LINK, PLAY_STORE_LINK } from "~/constants";
import { clsx } from "~/utils/classes";
import { isDeviceIos } from "~/utils/env";
import { trackEvent } from "~/utils/trackEvent";
import { Logo } from "./icons/Logo";

export const AppRedirect = () => {
	createEffect(() => {
		trackEvent("app_redirect.shown");
		setTimeout(() => {
			let link = isDeviceIos() ? APP_STORE_LINK : PLAY_STORE_LINK;
			window.location.href = link;
		}, 1000);
	});
	return (
		<>
			<div class="flex flex-col center w-screen h-screen">
				<div class="flex row items-center space-x-3">
					<div class="w-12 aspect-square pt-1">
						<Logo />
					</div>
				</div>
				<p class={clsx("text-xl md:text-2xl font-semibold pt-6", "animate-pulse")}>
					Redirecting to {isDeviceIos() ? "App Store" : "Play Store"}...
				</p>
			</div>
		</>
	);
};
